import { useCallback, useContext } from 'react'
import { AppStateContext } from './AppStateContext'

interface IsRefreshTransactionsResult {
  saveIsRefreshTransactions: (isRefreshTransactions: boolean | undefined) => void
  removeIsRefreshTransactions: () => void
}

export const useRefreshTransactions: () => IsRefreshTransactionsResult = () => {
  const { setIsRefreshTransactionsInStore, removeIsRefreshTransactionsFromStore } = useContext(AppStateContext)
  const saveIsRefreshTransactions = useCallback(
    (isRefreshTransactions: boolean | undefined) => {
      setIsRefreshTransactionsInStore(isRefreshTransactions)
    },
    [setIsRefreshTransactionsInStore],
  )

  const removeIsRefreshTransactions = useCallback(
    () => removeIsRefreshTransactionsFromStore(),
    [removeIsRefreshTransactionsFromStore],
  )

  return {
    saveIsRefreshTransactions,
    removeIsRefreshTransactions,
  }
}
